<script>
import Dialog from "base-components/Dialog";

export default {
  name: "Dialog",
  props: Dialog.props,
  functional: true,
  render(h, context) {
    const slots = context.slots();
    const children = Object.keys(slots).reduce((arr, key) => arr.concat(slots[key]), []);

    return h(
      Dialog,
      {
        // 透传 event 和 props
        on: context.listeners,
        props: {
          ...context.props,
          showClose: true,
          lockBgScroll: true,
        },
        // 透传 scopedSlots
        scopedSlots: context.scopedSlots,
        attrs: context.attrs,

        class: [context.data.class, context.data.staticClass],
        staticClass: "variant",
      },
      children
    );
  },
};
</script>

<style lang="scss">
$page-width: 375;
@import "~style/tool";

.Dialog.variant {
  .Dialog__mask {
    background: rgba(0, 0, 0, 0.8);
  }

  .Dialog__box {
    width: rem(310px);
    overflow: visible;
  }

  .Dialog__close {
    width: 36px;
    height: 36px;
    top: -20px - 36px;
    right: -2px;
    background-image: url("./img/dialog-close.png");
    background-size: cover;
  }
}
</style>
